import { rem } from "~/utils";

/**
 * Page/layout max-width
 */
const MAX_WIDTH = 1400;

const MAX_WIDTH_REM = rem(1400);

export { MAX_WIDTH, MAX_WIDTH_REM };
